import {
    mapState,
    mapActions
} from 'vuex'
import QualityImg from '@/components/qualityImg/qualityImg.vue'
import Sku from './fc-sku/index'
import { Stepper, NoticeBar } from 'vant'
import _ from 'lodash'

// 找出未选择的
function findemtryIndex (object) {
    let i = 0
    for (const key in object) {
        if (!object[key]) return i
        i++
    }
}
// 对象转数组
function objectToArray (obj) {
    let arr = []
    for (const key in obj) {
        if (!isNaN(Number(key[1]))) {
            arr.push(obj[key])
        }
    }
    return arr
}
export default {
    name: 'Sku',
    components: {
        Stepper,
        [NoticeBar.name]: NoticeBar,
        QualityImg,
        'fc-sku': Sku
    },
    props: {
        keyId: {
            type: String,
            value: 'id'
        },
        // 所有规格
        isMoreThan: {
            type: Boolean,
            value: false
        },
        skus: {
            type: Object,
            value: {
                sku: '',
                initialSku: '',
                spu: ''
            }
        },
        // 是否包含购买按钮
        hasBuyBtn: {
            type: Boolean,
            default: true
        },
        // 初始化选中规格
        initsku: {
            type: Object,
            value: {}
        },
        // 商品默认数量
        goodsNum: {
            type: Number,
            value: 1
        },
    },
    watch: {
        /* 监听 默认商品数量 给一个中间值 */
        goodsNum (n) {
            if (typeof n !== 'undefined') {
                this.stepperNum = n
            }
        },
        // 监听选中状态，并且修改库存
        selectedSkuComb (n) {
            if (n) {
                let stockNum = Number(n.stock_num)
                if (stockNum >= 99) {
                    this.quota = 99
                } else {
                    this.quota = Number(n.stock_num)
                }
            }
        },
        // 接口返回的规格参数
        skus (newV) {
            if (newV) {
                [this.skusAttr, this.filterNotSelectedText] = this.getAttrs(newV.sku.tree)
                this.skuDetail = { ...newV }
                this.resSuccess = true
                this.selectedSku = newV.initialSku
                this.skuDetailInitId = newV.initialSku.id
                const keyId = this.keyId || 'id'
                this.selectedSkuComb = { ...newV.sku.list.filter(item => Number(newV.initialSku[keyId]) === Number(item[keyId]))[0] }
            }
        }
    },
    data () {
        return {
            resSuccess: false,
            skuDetailInitId: 0,
            skuDetail: {
                spu: {},
                sku: {}
            },
            stepperNum: 1, // 商品数量
            show: false, // 显示状态
            initialSku: '', // 默认选中的规格
            quota: 99, // 限购数量
            selectedSkuComb: '', // 选中的规格参数，展示在规格头部
            selectedSku: '', // 选中的属性
            skusAttr: [], // 默认的所属的行名字
            filterNotSelectedText: '', // 没有选中的规格属性名称
        }
    },
    created () {
        if (this.goodsNum > 0) {
            this.stepperNum = this.goodsNum
        }
    },
    computed: {
        ...mapState({}),
        // 展示在头部，显示已经选择的sku
        currentSkuText () {
            // 当selectedSku发生变化的时候，展示在头部，触发点在规格切换选择的时候，发生变动产生事件
            let {
                selectedSku
            } = this
            if (selectedSku) {
                return objectToArray(_.pick(selectedSku, ['s1', 's2']))
                    .filter(item => item)
                    .join(';')
            } else {
                return ''
            }
        },
        // 是否开启秒杀 true 是秒杀状态 false是关闭秒杀状态
        isStart () {
            // 3.获取秒杀库存，当不在秒杀时段或此时段秒杀库存=0时，展示原有库存
            // 判断是否是秒杀规格
            if (this.selectedSkuComb && this.selectedSkuComb.is_seckill === 1) {
                let { seckill_status, seckill_stock, seckill_timestamp } = this.selectedSkuComb
                // 当sku正在秒杀时段中时，且秒杀库存≠0时，展示秒杀价和原价
                // 1.当sku正在秒杀时段中时，且秒杀库存≠0时，展示秒杀价和原价；
                if ((seckill_status === 2 &&  seckill_stock > 0 && seckill_timestamp > 0)) {
                    return true
                } else {
                    // 2.不在秒杀时段，或此时段秒杀库存=0时，展示平常价（正常铺货+正常毛利）；
                    return false
                }
            } else {
                // 2.不在秒杀时段，或此时段秒杀库存=0时，展示平常价（正常铺货+正常毛利）；
                return false
            }
        },
        notSupport () {
            let {
                selectedSku,
                selectedSkuComb
            } = this
            const hasSupport = Object.keys(selectedSkuComb).some(item => item === 'support')
            if (hasSupport) {
                const list = this.skus.sku.list
                const currentSkuText = [selectedSku.s1, selectedSku.s2].join(';')
                return list.some(item => {
                    const text = [item.s1, item.s2].join(';')
                    return text === currentSkuText && item.support
                })
            } else {
                return true
            }
        }
    },
    methods: {
        ...mapActions([]),
        // 获取属性值
        getAttrs (array) {
            let arr = []
            let string = ''
            array.forEach((item, index) => {
                let val = item['k']
                arr.push(val)
                if (index === array.length - 1) {
                    string += val
                } else {
                    string += val + ','
                }
            })
            return [arr, string]
        },
        // 打开sku
        open () {
            this.show = true
        },
        // 关闭sku
        close () {
            /* 这个产品有点怪 不知道为什么要关闭弹窗的时候 触发确定事件 */
            // const params = {
            //     selectedSkuComb: this.selectedSkuComb,
            //     selectedSku: this.selectedSku
            // }
            // this.show && this.accomplish(params, 'confirm')
            this.show = false
            this.$emit('close')
        },
        // 规格切换选中进行时
        onSkuSelected (e) {
            const {
                selectedSkuComb,
                selectedSku
            } = e
            if (selectedSku) {
                this.selectedSku = {
                    ...selectedSku
                }
            }
            if (selectedSkuComb) {
                this.selectedSkuComb = selectedSkuComb
            }
        },
        // 检查规格是否选择完整
        check (e) {
            let {
                selectedSku,
                selectedSkuComb
            } = e
            return new Promise((resolve, reject) => {
                // 开启了规格的情况
                if (this.skuDetail.sku.none_sku === 1) {
                    if (selectedSkuComb) {
                        resolve()
                    } else {
                        // 找出为空的属性值的下班
                        reject(findemtryIndex(selectedSku))
                    }
                } else {
                    // 关闭了设置sku规格的情况
                    resolve()
                }
            })
            // }
        },
        handleStepperChange (num) {
            this.stockNumUp(num)
        },
        stockNumUp (num) {
            return new Promise((resolve, reject) => {
                let { purchase_limit, seckill_stock } = this.selectedSkuComb
                let isunlimited = purchase_limit === 0
                const LIMIT_TYPE = {
                    SECKILL_STOCK: purchase_limit >  seckill_stock ? seckill_stock : isunlimited ? seckill_stock : purchase_limit,
                    STOCK_LIMIT: this.selectedSkuComb.stock_num
                }
                if (this.isStart) {
                    if (num > Number(LIMIT_TYPE.SECKILL_STOCK)) {
                        if (isunlimited) {
                            this.stepperNum = Number(LIMIT_TYPE.SECKILL_STOCK)
                            return this.$toast(`最多能购买${LIMIT_TYPE.SECKILL_STOCK}件`)
                        } else {
                            this.stepperNum = Number(LIMIT_TYPE.SECKILL_STOCK)
                            return this.$toast(`限购${LIMIT_TYPE.SECKILL_STOCK}件`)
                        }
                    }
                    this.stepperNum = num
                } else {
                    if (num > Number(LIMIT_TYPE.STOCK_LIMIT)) {
                        this.stepperNum = Number(LIMIT_TYPE.STOCK_LIMIT)
                        return this.$toast(`最多能购买${Number(LIMIT_TYPE.STOCK_LIMIT)}件`)
                    }
                    this.stepperNum = num
                }
            })
        },
        /**
         *
         * 完成 0 与立即购买1
         */
        accomplish (e, type) {
            // 判断是否已经选择
            this.check(e)
                .then(res => {
                    if (e.selectedSkuComb.stock_num > 0) {
                        e.selectedNum = this.stepperNum
                        this.$emit(type, e)
                    } else {
                        this.$toast('库存不足')
                    }
                })
                .catch(err => {
                    this.$toast('请选择：' + this.skusAttr[Number(err)])
                })
        }
    },
    destroyed () { }
}
